import type { ResultOf, VariablesOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const MissionForm_Mission_Init_Mutation = graphql(`
  mutation MissionForm_Mission_Init(
    $mission: MissionInput!
    $versionData: VersionDataInput
  ) {
    initMission(mission: $mission, versionData: $versionData) {
      _id
    }
  }
`);

export type MissionInput = VariablesOf<
  typeof MissionForm_Mission_Init_Mutation
>['mission'];

export type MissionForm_Mission_Init_Result = ResultOf<
  typeof MissionForm_Mission_Init_Mutation
>;

export const useInitMissionMutation = () =>
  useGraphQLMutation(MissionForm_Mission_Init_Mutation);
